import React from "react";
import { useAdminContext } from "../provider/AdminContext";
import Login from "./login";
import AdminDashboard from "./AdminDashboard";
import CompanyDetail from "./CompanyDetail";
import UsersTable from "./UsersTable";
import ProjectsGrid from "./ProjectsGrid";
import MappingsGrid from "./MappingsGrid";

const VIEWS = {
  companies: AdminDashboard,
  companyDetail: CompanyDetail,
  users: UsersTable,
  projects: ProjectsGrid,
  mappings: MappingsGrid,
};

const AdminContent = () => {
  const { allowUser, viewStack } = useAdminContext();

  if (!allowUser) {
    return <Login />;
  }

  const currentView = viewStack[viewStack.length - 1];
  const ViewComponent = VIEWS[currentView] || AdminDashboard;

  return <ViewComponent />;
};

export default AdminContent;
